// extracted by mini-css-extract-plugin
module.exports = {"container":"b2JZUh","header":"_14Toqg","content":"F65BbX","passengerName":"s0fpY0","pnrNumber":"_2aZw78","container--mobile":"muGDoa"};